<div class="search-wrap" #searchRoot [class.search-wrap--stretch]="stretch()">
  <svg class="search-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
  <input
    #searchField
    type="search"
    class="search-input"
    [placeholder]="searchPlaceholder()"
    autocomplete="off"
    [attr.aria-label]="searchPlaceholder()"
    aria-autocomplete="list"
    [attr.aria-expanded]="showSearchDropdown()"
    (input)="onSearchInput($any($event.target).value)"
    (focus)="onSearchFocus()"
    (blur)="onSearchBlur()"
  />
  @if (showSearchDropdown()) {
    <div class="search-dropdown" role="listbox" aria-label="Resultados da busca">
      @if (searchLoading()) {
        <p class="search-dropdown__message">Buscando…</p>
      } @else if (searchError()) {
        <p class="search-dropdown__message search-dropdown__message--error">Não foi possível buscar. Tente de novo.</p>
      } @else if (showNoResults()) {
        <p class="search-dropdown__message">Nenhuma pessoa encontrada.</p>
      } @else {
        <ul class="search-dropdown__list">
          @for (u of searchResults(); track u.externalId || u.username) {
            <li class="search-dropdown__item" role="option">
              <button
                type="button"
                class="search-dropdown__btn"
                (mousedown)="$event.preventDefault()"
                (click)="pickUser(u)"
              >
                @if (u.profilePictureUrl) {
                  <img class="search-dropdown__avatar" [src]="u.profilePictureUrl" alt="" width="36" height="36" />
                } @else {
                  <span class="search-dropdown__avatar search-dropdown__avatar--placeholder" aria-hidden="true">
                    {{ displayName(u).charAt(0).toUpperCase() }}
                  </span>
                }
                <span class="search-dropdown__text">
                  <span class="search-dropdown__name">{{ displayName(u) }}</span>
                  @if (handleLabel(u)) {
                    <span class="search-dropdown__handle">{{ handleLabel(u) }}</span>
                  }
                </span>
              </button>
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
